import { useApp } from "../context/AppContext";
import { useProjects } from "../hooks/useProjects";
import ProjectCard from "./ProjectCard";
import "./ProjectsPage.css";

function ProjectsPage() {
  const { t } = useApp();
  const projects = useProjects();

  return (
    <div className="projects-page page-enter">
      <div className="code-line" style={{ marginBottom: 16, fontSize: 13 }}>
        <h1 className="syn-green">Projects</h1>
      </div>

      <div className="code-comment">
        <span className="syn-comment">
          // {t("projects.title")} — {t("projects.subtitle")}
        </span>
      </div>
      <div className="code-comment">
        <span className="syn-comment">// {projects.length} projects</span>
      </div>

      <div className="projects-grid">
        {projects.map((project) => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
}

export default ProjectsPage;
